import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Building2, ShieldCheck, KeyRound, Bell } from "lucide-react";
import { api } from "../lib/api";
import { useAuth } from "../lib/auth";
import { toast } from "sonner";

export default function Settings() {
  const { user, org } = useAuth();
  const [form, setForm] = useState({ full_name: "", email: "" });
  const [busy, setBusy] = useState(false);
  const [emailNotifications, setEmailNotifications] = useState(true);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
  const loadUser = async () => {
    try {
      setLoading(true);

      const { data } = await api.get("/auth/me");
      console.log("adaaatra",data, data.user.full_name )
      setForm({
        full_name: data.user.full_name || "",
        email: data.user.email || "",
      });

      setEmailNotifications(data.org?.email_trigger ?? true);

    } catch (err) {
      toast.error("Failed to load user details");
    } finally {
      setLoading(false);
    }
  };

  loadUser();
}, []);

  const save = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await api.patch("/users/me",{
        ...form,
        email_trigger: emailNotifications,
      });
      toast.success("Personal details saved");
    } catch (e) {
      toast.error(e?.response?.data?.detail || "Save failed");
    } finally {
      setBusy(false);
    }
  };

  // useEffect(() => {
  //   if (user) {
  //     console.log("ueserere")
  //     setForm({
  //       full_name: user.full_name || "",
  //       email: user.email || "",
  //     });

  //     setEmailNotifications(org.email_trigger ?? true);
  //   }
  // }, [user]);

  // useEffect(() => {
  //   if (user && org) {
  //     setForm({
  //       full_name: user.full_name || "",
  //       email: user.email || "",
  //     });
  //     console.log("org.email_trigger ",org.email_trigger )
  //     setEmailNotifications(org.email_trigger ?? true);
  //   }
  // }, [user, org]);

  // const toggleEmailNotifications = () => {
  //   setEmailNotifications(prev => !prev);
  // };

  const toggleEmailNotifications = async () => {
  const next = !emailNotifications;

  try {
    await api.put("/me/notifications", {
      email_trigger: next,
    });

    setEmailNotifications(next);

    toast.success(
      next
        ? "Daily email updates enabled."
        : "Daily email updates disabled."
    );
  } catch (e) {
    toast.error(
      e?.response?.data?.detail ||
      "Unable to update notification settings."
    );
  }
};

  return (
    <div className="p-8 lg:p-12" data-testid="settings-page">
      <div className="type-eyebrow text-[#64748B]">Account</div>
      <h1 className="type-h1 text-[#0F1F3D] mt-3">Settings</h1>

      <div className="mt-10 grid grid-cols-1 lg:grid-cols-12 gap-6">
        {/* Form column */}
        <form onSubmit={save} className="lg:col-span-8 bg-white border border-[#E2E8F0] rounded-lg p-8 space-y-7">
          <div>
            <div className="type-eyebrow text-[#0F1F3D]">Personal details</div>
            <div className="type-body text-[#64748B] mt-2">Update your name and email address.</div>
          </div>

          <div>
            <label className="type-eyebrow text-[#64748B]">Full name</label>
            <input
              value={form.full_name}
              onChange={(e) => setForm({ ...form, full_name: e.target.value })}
              data-testid="settings-fullname-input"
              className="mt-3 w-full px-3 py-2.5 rounded-md border border-[#E2E8F0] type-body focus:outline-none focus:ring-2 focus:ring-[#0F1F3D]"
            />
          </div>

          <div>
            <label className="type-eyebrow text-[#64748B]">Email address</label>
            <input
              type="email"
              value={form.email}
              onChange={(e) => setForm({ ...form, email: e.target.value })}
              data-testid="settings-email-input"
              className="mt-3 w-full px-3 py-2.5 rounded-md border border-[#E2E8F0] type-body focus:outline-none focus:ring-2 focus:ring-[#0F1F3D]"
            />
          </div>

          <div>
            <label className="type-eyebrow text-[#64748B]">Role</label>
            <div className="mt-3 px-3 py-2.5 rounded-md border border-[#E2E8F0] bg-[#F8F9FA] type-body text-[#475569] capitalize" data-testid="settings-role-display">
              {user?.role?.replace("_", " ")}
            </div>
            <div className="type-caption text-[#94A3B8] mt-2">Role is managed by an administrator.</div>
          </div>

          <button
            type="submit"
            disabled={busy}
            data-testid="settings-save-button"
            className="px-5 py-2.5 rounded-md bg-[#0F1F3D] text-white type-body-sm font-medium hover:bg-[#172A4F] disabled:opacity-50"
          >
            {busy ? "Saving..." : "Save changes"}
          </button>
        </form>

        {/* Right rail */}
        <aside className="lg:col-span-4 space-y-4">
          <div className="bg-white border border-[#E2E8F0] rounded-lg p-6">
            <div className="flex items-center gap-2 type-eyebrow text-[#64748B]">
              <Building2 className="h-3.5 w-3.5" /> Organisation
            </div>
            <div className="type-h3 text-[#0F1F3D] mt-3">{org?.name || "—"}</div>
            <div className="type-caption text-[#64748B] mt-1 capitalize">Plan · {org?.plan || "trial"}</div>
            {/* <Link to="/app/usage" className="inline-flex items-center gap-1 type-caption font-semibold text-[#0F1F3D] hover:underline mt-4">
              View usage and credits →
            </Link> */}
          </div>

          <div className="bg-white border border-[#E2E8F0] rounded-lg p-6">
            <div className="flex items-center gap-2 type-eyebrow text-[#64748B]">
              <ShieldCheck className="h-3.5 w-3.5" /> Security
            </div>
            <div className="type-body-sm text-[#475569] mt-3">Password resets and session management are handled by your org admin.</div>
          </div>

          <div className="bg-white border border-[#E2E8F0] rounded-lg p-6">
            <div className="flex items-center gap-2 type-eyebrow text-[#64748B]">
              <Bell className="h-3.5 w-3.5" />
              Notifications
            </div>

            <div className="mt-5 flex items-start justify-between gap-4">
              <div>
                <div className="type-body font-medium text-[#0F1F3D]">
                  Daily email updates
                </div>

                <div className="type-body-sm text-[#64748B] mt-1">
                  Receive a daily email digest for your project updates.
                </div>
              </div>

              {/* <button
                type="button"
                onClick={() => setEmailNotifications(!emailNotifications)}
                className={`relative inline-flex h-6 w-11 items-center rounded-full transition-colors duration-200 ${emailNotifications ? "bg-[#2563EB]" : "bg-[#CBD5E1]"
                  }`}
                data-testid="email-notification-toggle"
              >
                <span
                  className={`inline-block h-5 w-5 transform rounded-full bg-white transition-transform duration-200 ${emailNotifications ? "translate-x-5" : "translate-x-0.5"
                    }`}
                />
              </button> */}

              <button
                type="button"
                onClick={toggleEmailNotifications}
                className={`relative inline-flex h-6 w-11 items-center rounded-full transition-colors duration-200 ${
                  emailNotifications ? "bg-[#2563EB]" : "bg-[#CBD5E1]"
                }`}
              >
                <span
                  className={`inline-block h-5 w-5 transform rounded-full bg-white transition-transform duration-200 ${
                    emailNotifications ? "translate-x-5" : "translate-x-0.5"
                  }`}
                />
              </button>
            </div>

            <div className="mt-5 border-t border-[#E2E8F0] pt-5">
              <div className="type-body-sm text-[#94A3B8]">
                WhatsApp alerts coming soon.
              </div>
            </div>
          </div>
        </aside>
      </div>
    </div>
  );
}
